import { useEffect, useState } from 'react'

/**
 * Returns a preview image or video url from a source file or url.
 */
export function useCreationSourcePreviewUrl(source?: File | string): string {
    const [previewUrl, setPreviewUrl] = useState('')

    useEffect(() => {
        if (!source) return

        let objectUrl = ''

        if (typeof source === 'string') {
            setPreviewUrl(source)
        } else {
            objectUrl = URL.createObjectURL(source)
            setPreviewUrl(objectUrl)
        }

        return () => {
            objectUrl && URL.revokeObjectURL(objectUrl)
        }
    }, [source])

    return previewUrl
}
